<script lang="ts">
  import { _ } from 'svelte-i18n';
  // The mark beside a measure that has a target: reached, close to it, or not reached. One look and one set of words for every
  // table and for the header of the report. 'short' is a projection that ends under its target: a plan in progress, so no cross,
  // only the words for a screen reader and the hover text. 'unknown' is a result that could not be judged.
  export type Status = 'ok' | 'warn' | 'miss' | 'short' | 'unknown' | null | undefined;

  export let status: Status = null;
  // On the dark header the tones are lighter.
  export let onDark = false;
  // A projection reads "On track" where a result reads "Reached".
  export let reached: string | null = null;
  export let large = false;

  $: mark = ({
    ok: { icon: '✓', text: reached ?? $_('report.table.reached'), light: 'text-green-300', dark: 'text-green-600' },
    warn: { icon: '⚠', text: $_('report.mark.close'), light: 'text-amber-300', dark: 'text-amber-600' },
    miss: { icon: '✗', text: $_('report.mark.miss'), light: 'text-red-300', dark: 'text-red-600' },
    short: { icon: '', text: $_('report.mark.short'), light: 'text-white/60', dark: 'text-zinc-500' },
    unknown: { icon: '?', text: $_('report.mark.unknown'), light: 'text-white/60', dark: 'text-zinc-400' },
  } as const)[status ?? 'unknown'];
</script>

{#if status}
  <span class="inline-block text-center font-semibold leading-none {large ? 'text-lg' : ''} {onDark ? mark.light : mark.dark}" role="img" aria-label={mark.text} title={mark.text}>{mark.icon}</span>
{/if}
